import { PlusCircleOutlined } from "@ant-design/icons";
import { Spin, Table } from "antd";
import { useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
  OrganizationMutableProperties,
  useCreateOrganization,
  useMyUser,
  useOrganizations,
} from "../../api";
import { Organization } from "../../api/models";
import { OrganizationPropertyModal } from "../../components/OrganizationPropertyModal";
import { AuthContext } from "../../contexts/authContext";
import { toAntdPagination } from "../../util";
import { useActiveUserRoles } from "../../util/useActiveUserRoles";

export function Organiztations() {
  const history = useHistory();
  const { t } = useTranslation();
  const isMounted = useRef(true);

  const authContext = useContext(AuthContext);

  const { isSolutionOperator, isSCBOneDataAnalyst, isRoadSafetyManager } =
    useActiveUserRoles();

  const myorg = useMyUser(
    authContext.currentUser?.accessToken?.payload?.sub || ""
  );

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (
      myorg.value &&
      isMounted.current &&
      (isSCBOneDataAnalyst || isRoadSafetyManager)
    ) {
      history.push("/organizations/" + myorg.value?.org.id);
    }
  }, [myorg.value, isMounted]);

  const organiztations = useOrganizations(myorg.loading && isSCBOneDataAnalyst);
  const createOrganization = useCreateOrganization();

  const onCreateOrganization = async (org: OrganizationMutableProperties) => {
    const organization = await createOrganization(org);
    if (isMounted.current) {
      history.push("/organizations/" + organization.id);
    }
  };

  if ((!organiztations.loading && !organiztations.value) || myorg.loading) {
    return <Spin className="centered" />;
  }

  return (
    <Table
      sticky
      dataSource={organiztations.value?.items || []}
      rowKey="id"
      size="middle"
      scroll={{ y: "calc(100vh - 250px)" }}
      loading={organiztations.loading}
      onRow={(record) => {
        return {
          onClick: (event) => {
            history.push("/organizations/" + record.id);
          },
          style: {
            cursor: "pointer",
          },
        };
      }}
      columns={[
        {
          title: t("organization:name"),
          render: (c: Organization) => <>{c.name}</>,
        },
      ]}
      pagination={toAntdPagination(organiztations, false)}
      footer={() =>
        isSolutionOperator ? (
          <OrganizationPropertyModal
            title={t("organization:new")}
            modalButtonIcon={<PlusCircleOutlined />}
            onSave={onCreateOrganization}
          />
        ) : null
      }
    />
  );
}
